export enum EEstimatedTimeReportType {
    Weekly,
    Daily
}
